import styled from "styled-components";

interface ModalProps {
  readonly isSectionModal?: boolean;
  readonly isMobile: boolean;
}

export const StyledModal = styled.div<ModalProps>`
  position: ${(props) =>
    !props.isSectionModal || props.isMobile ? "fixed" : "absolute"};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: ${(props) => (props.isMobile ? 1000000001 : 2000000)}; ;
`;

StyledModal.defaultProps = {};
